import { Component, OnInit  } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { ClienteSelectRedux } from '../../providers/redux/clienteselect/clienteselect';
import { UtilsRedux } from '../../providers/redux/utils/utils';
import { Storage } from '@ionic/storage'
import { CajaProvider } from '../../providers/caja/caja';
import { ParametrosGeneralesRedux } from '../../providers/redux/parametrosgenerales/parametrosgenerales';


@IonicPage()
@Component({
  selector: 'page-whatsapp',
  templateUrl: 'whatsapp.html',
  providers: [ClienteSelectRedux, UtilsRedux, ParametrosGeneralesRedux]
})
export class WhatsappPage implements OnInit{
  data:any[] = []
  paginaActual: number = 1;
  buscarTexto: string = '';
  item: string = '';
  listaClientes = [];
  numeroTelefono: string = '';
  dataImprimir =  []
  espacios: boolean = true
  companiasId
  descripcionFactura: string = ''
  titulo: string = ""
  piefactura: string = ""
  entidad: boolean = false
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public viewControllers:ViewController,
    public clienteSelectRedux: ClienteSelectRedux,
              public utilsRedux: UtilsRedux,
              public storage: Storage,
              public servicio: CajaProvider,
              public utilsParametrosGeneralesRedux: ParametrosGeneralesRedux) {
    if(this.navParams.get('dataImprimir')){
      let data = this.navParams.get('dataImprimir')
      this.numeroTelefono = this.navParams.get('numeroTelefono')
      this.espacios = this.navParams.get('espacios')
      this.descripcionFactura = this.navParams.get('descripcionFactura')
      this.entidad = this.navParams.get('entidad')
      if(this.entidad != undefined && this.entidad) {
        this.dataImprimir = data
      } else {
        this.dataImprimir = JSON.parse(data)
      }


    }

    this.buscarDatosGenerales()
  }

  async ngOnInit() {
    this.storage.get('titulows')
    .then((value)=> {
      let titulo = value
      if(titulo) {
        this.titulo = titulo
      }
    })

    this.storage.get('piefacturaws')
    .then((value)=> {
      let titulo = value
      if(titulo) {
        this.piefactura = titulo
      }
    })


  }
  buscarClientes(companiasId) {
    this.servicio.buscarClientesPorCompaniaAll(companiasId)
    .subscribe((data: any)=>{
      let clientes: any = data;
      this.listaClientes = clientes;
      this.data = this.listaClientes;
    })
  }

  async buscarDatosGenerales() {
    let buscarParametrosGeneralesStore: any = await this.utilsParametrosGeneralesRedux.buscarParametrosGeneralesStore()
    if(buscarParametrosGeneralesStore !== null && buscarParametrosGeneralesStore.parametrosGenerales !== null) {
      this.companiasId = buscarParametrosGeneralesStore.parametrosGenerales[0][0].companiasId
      this.buscarClientes(this.companiasId);
    } else {
      this.storage.get('companiasId').then((val) => {
        this.buscarClientes(val);
      })
    }
  }
  buscar(event) {
    this.buscarTexto = event.value;
  }
  devolverValor(item) {
    this.item = item;
    let display = item.display
    let displaSplit = display.split('-')
    this.numeroTelefono = displaSplit[1]
    this.numeroTelefono = this.numeroTelefono.trim()
  }

  async buscarValoresSelectStore() {

        let clienteSelect: any = await this.clienteSelectRedux.buscarClienteSelectStore();
        this.data = clienteSelect !== undefined && clienteSelect.clienteselect !== undefined &&  clienteSelect.clienteselect.length > 0 ? clienteSelect.clienteselect : []
        if(this.data.length>0) {
          let values: any = this.data.map((items: any) => {
            return {value:items.clientesId,display:items.nombreCliente}
          })
          this.data = values
        }

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad WhatsappPage');
  }

  dismiss(){
    this.viewControllers.dismiss();
  }

  submit(){
   this.viewControllers.dismiss(this.data);
  }

  enviarWhatsApp() {
        let encabezado = undefined
        let piefactura = undefined
        if(this.entidad) {
          this.enviarWhatsAppEntidad(this.dataImprimir,piefactura)
          return
        }
        if(this.titulo != '') {
          encabezado = this.titulo
         this.storage.set('titulows',this.titulo)
        }
        if(this.piefactura != '') {
          piefactura = this.piefactura
         this.storage.set('piefacturaws',this.piefactura)
        }



        let datanew = this.dataImprimir
        let recibo = ''

        let data = []
        let numero = this.numeroTelefono
        if(encabezado != undefined) {
          recibo += `${encabezado}`+ '\n';
          recibo += '\n';
        }
        for (let index:any = 0; index < datanew.length; index++) {

          for (const propiedad in datanew[index]) {
            const nombre = propiedad;
            const valor = datanew[index][propiedad];
            if(nombre == 'reciboCaja') {
              recibo += `${valor}`+ '\n';
            }else {
              recibo += `${nombre}: ${valor}`+ '\n';
            }
          }
          if(this.descripcionFactura != '' && this.descripcionFactura  != undefined) {
            recibo += `Observación: `+ '\n';
            recibo += `${this.descripcionFactura} `+ '\n';
          }

          if(this.espacios) {
            recibo +=  '  --------------------------------------- ' + '\n'
          }
          data.push(recibo)
        }

        if(piefactura != undefined) {
          recibo += `${piefactura}`+ '\n';
          recibo += '\n';
        }

        this.sendWs(numero, recibo)
  }

  enviarWhatsAppEntidad(item,piefactura) {
    let encabezado = undefined
    if(this.titulo != '') {
      encabezado = this.titulo
     this.storage.set('titulows',this.titulo)
    }
    if(this.piefactura != '') {
      piefactura = this.piefactura
     this.storage.set('piefacturaws',this.piefactura)
    }
    let recibo = ''
    if(encabezado != undefined) {
      recibo += `${encabezado}`+ '\n';
      recibo += '\n';
    }
    let data = []
    let numero =  this.numeroTelefono
    const numerovalorFactura = item.valorFactura.toLocaleString('en');
    const numerovalorPagado = item.valorPagado.toLocaleString('en');
    const numerovalorPendiente = item.valorPendiente.toLocaleString('en');
    const fechaFormateada: string = item.fecha.substring(0, 10);


    recibo +=  '   Fecha: ' + fechaFormateada + '\n'
    if(item.fechaPagoReal !== undefined) {
      const fechaOriginal: string = item.fechaPagoReal;
      const fechaParseada: Date = new Date(Date.parse(fechaOriginal));
      const fechaFormateadaPagoReal: string = fechaParseada.toISOString().slice(0, 10);
      const date1: Date = new Date(fechaFormateada);
      const date2: Date = new Date(fechaFormateadaPagoReal);
      if(date2 > date1) {
        recibo +=  '   Fecha pago: ' + fechaFormateada + '\n'
      } else {
        recibo +=  '   Fecha pago: ' + fechaFormateadaPagoReal + '\n'
      }

    }
    recibo +=  '   Nombre: ' + item.nombreCompleto + '\n'
    recibo +=  '   Factura: ' + item.numeroFactura + '\n'
    recibo +=  '   Comprobante: ' + item.comprobantePago + '\n'
    recibo +=  '   Valor factura: ' + numerovalorFactura + '\n'
    recibo +=  '   Pagado: ' + numerovalorPagado + '\n'
    recibo +=  '   Pendiente: ' + numerovalorPendiente + '\n'
    if(this.descripcionFactura != '' && this.descripcionFactura  != undefined) {
      recibo += `Observación: `+ '\n';
      recibo += `${this.descripcionFactura} `+ '\n';
    }
    if(piefactura != undefined) {
      recibo += `${piefactura}`+ '\n';
      recibo += '\n';
    }
    if(this.espacios) {
      recibo +=  '  --------------------------------------- ' + '\n'
    }
    data.push(recibo)
    this.sendWs(numero, recibo)

  }

  sendWs(numero :any, recibo: any) {
    const url = `https://api.whatsapp.com/send?phone=${numero}&text=${encodeURIComponent(
      recibo
    )}`;
    window.open(url, '_system');
  }

}



// WEBPACK FOOTER //
// ./src/pages/whatsapp/whatsapp.ts